module.exports = __webpack_public_path__ + "static/media/pig-purple.8e75a56a.webp";